
import { Switch } from "@/components/ui/switch";
import { MessageSquare } from "lucide-react";

interface ReviewSettingsProps {
  showRatings: boolean;
  showFeaturedReviews: boolean;
  onToggleRatings: (checked: boolean) => void;
  onToggleFeaturedReviews: (checked: boolean) => void;
}

export const ReviewSettings = ({ 
  showRatings, 
  showFeaturedReviews, 
  onToggleRatings, 
  onToggleFeaturedReviews 
}: ReviewSettingsProps) => {
  return (
    <div className="w-full md:w-2/3 p-6 bg-card rounded-xl border shadow-sm">
      <div className="flex items-center gap-3 mb-4">
        <MessageSquare className="h-5 w-5 text-primary" />
        <h3 className="text-lg font-semibold">Review Settings</h3>
      </div>
      
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-sm">Show ratings publicly</span>
          <Switch 
            checked={showRatings}
            onCheckedChange={onToggleRatings}
          />
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm">Show featured reviews</span>
          <Switch 
            checked={showFeaturedReviews}
            onCheckedChange={onToggleFeaturedReviews}
          />
        </div>
      </div>
    </div>
  );
};

